import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import JQuery from "jquery";

let $=JQuery.noConflict();

export class ZIDXAccountSearchFormIntegration implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSearchFormIntegrationContainer";
    }
    render(){
        // console.log("Search Form Integration");
        // "<div class=\"peakidxSimpleSearchForm\">Simple Search Form</div>"
        let table=this.zidx.peakidxShadowRoot.querySelector(".zidxAccountSearchFormIntegrationContainer .zidxRecordSort")!;
        let self=this;
        $(".zidxAccountSearchFormIntegrationContainer input").on("input", function(event:Event){
            self.generateSearchFormCode();
        });
        this.zidx.setupRecordSort(table, function(result:any){
            self.generateSearchFormCode();
        });
        this.generateSearchFormCode();
    }
    generateSearchFormCode(){

        let fields:string[]=[];
        let hideLabels="false";
        let rangeSearch="false";
        let rangeSideBySide="false";
        let layout="vertical";
        this.zidx.peakidxShadowRoot.querySelectorAll((".zidxAccountSearchFormIntegrationContainer input")).forEach((input:Element)=> {
            let inputElement=input as HTMLInputElement;
            if (inputElement.name.startsWith("show_fields") && inputElement.checked && inputElement.value != "") {
                fields.push(inputElement.value);
            }else if( inputElement.name == "hideLabels" && inputElement.value=="true" && inputElement.checked) {
                hideLabels="true";
            }else if( inputElement.name == "layout" && inputElement.value=="horizontal" && inputElement.checked) {
                layout="horizontal";
            }else if( inputElement.name == "rangeSearch" && inputElement.value=="true" && inputElement.checked) {
                rangeSearch="true";
            }else if( inputElement.name == "rangeSideBySide" && inputElement.value=="true" && inputElement.checked) {
                rangeSideBySide="true";
            }
        });
        let textareaWixElement=this.zidx.peakidxShadowRoot.querySelector((".zidxAccountSearchFormIntegrationContainer #searchFormEmbedWixCode"))! as HTMLTextAreaElement;
        if(textareaWixElement) {
            let json={
                name: "Search",
                "field-order": fields.join(","),
                "hide-labels": hideLabels,
                "layout": layout,
                "range-search": rangeSearch,
                "range-side-by-side": rangeSideBySide
            }
            textareaWixElement.value = JSON.stringify(json);
        }
        let textareaElement=this.zidx.peakidxShadowRoot.querySelector((".zidxAccountSearchFormIntegrationContainer #searchFormEmbedCode"))! as HTMLTextAreaElement;
        if(textareaElement) {
            textareaElement.value = '<div class="peakidxSimpleSearchForm" data-name="search" data-callback-function-name="" data-field-order="' + fields.join(",") + '" data-hide-labels="' + hideLabels + '" data-layout="' + layout + '" data-range-search="' + rangeSearch + '" data-range-side-by-side="' + rangeSideBySide + '">';
        }
        let textareaWordpressElement=this.zidx.peakidxShadowRoot.querySelector((".zidxAccountSearchFormIntegrationContainer #searchFormEmbedWordpressCode"))! as HTMLTextAreaElement;
        if(textareaWordpressElement){
            textareaWordpressElement.value='[peakidx-react-component name="search" callback-function-name="" field-order="'+fields.join(",")+'" hide-labels="'+hideLabels+'" layout="'+layout+'" range-search="'+rangeSearch+'" range-side-by-side="'+rangeSideBySide+'"]';
        }

    }
}